<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2YvfPC/tc-custom/9780253022394.jpg?1717895598156" alt="This image is the cover for the book Judaism and the West, New Jewish Philosophy and Thought"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Judaism and the West, New Jewish Philosophy and Thought
      </h1>
      <p class="bookDescription body article font2">
        <p>Grappling with the place of Jewish philosophy at the margin of religious studies, Robert Erlewine examines the work of five Jewish philosophers—Hermann Cohen, Martin Buber, Franz Rosenzweig, Abraham Joshua Heschel, and Joseph Soloveitchik—to bring them into dialogue within the discipline. Emphasizing the tenuous place of Jews in European, and particularly German, culture, Erlewine unapologetically contextualizes Jewish philosophy as part of the West. He teases out the antagonistic and overlapping attempts of Jewish thinkers to elucidate the philosophical and cultural meaning of Judaism when others sought to deny and even expel Jewish influences. By reading the canon of Jewish philosophy in this new light, Erlewine offers insight into how Jewish thinkers used religion to assert their individuality and modernity.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Erlewine
      </h2>
      
      <p class="authorDescription body article"><P>Robert Erlewine is Associate Professor of Religion at Illinois Wesleyan University. He is author of Monotheism and Tolerance: Recovering a Religion of Reason (IUP, 2009).</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5090c021